/* eslint-disable react/jsx-key */

import Color from '../Color.mjs'
import IconLetters from '../icons/IconLetters.jsx'

export default [
    [
        'UPT',
        '修改',

        <IconLetters
            borderColor={Color.LIGHT_ORANGE}
            letters="U"
            textColor="#000"
        />
    ],

    [
        'ADD',
        '增加',

        <IconLetters
            borderColor={Color.LIGHT_ORANGE}
            letters="C"
            textColor="#000"
        />
    ],

    [
        'DEL',
        '删除',

        <IconLetters
            borderColor={Color.LIGHT_ORANGE}
            letters="D"
            textColor="#000"
        />
    ],
]
